import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgWrapper = styled('svg', { label: 'SvgWrapper' })<PropsType>`
    height: auto;
`;

export const ChevronDownIcon = ( { className, onClick }: PropsType ): React.ReactElement => (
    <SvgWrapper width={10} height={6} fill='#fff' onClick={onClick} className={className} viewBox='0 0 10 6' xmlSpace='preserve'>
        <path
            fill='#fill'
            d='M5 3.586L1.707.293A1 1 0 10.293 1.707l4 4a1 1 0 001.414 0l4-4A1 1 0 108.293.293L5 3.586z'
        />
    </SvgWrapper>
);

